import { OpenRegisterPanelController } from './open-register-panel.controller'
import template from './open-register-panel.html'

/**
 * Provides a panel stating that the register is closed with an option to open it.
 *
 * @type {component}
 */
export const OpenRegisterPanelComponent = {
  bindings: {
    register: '<',
    webRegisterOnline: '<',
    minimal: '<?',
  },
  controller: OpenRegisterPanelController,
  template,
}
